export const TYPE = {
  compact: 'compact',
  compactSide: 'compactSide',
  uniformSide: 'uniformSide',
  uniformFull: 'uniformFull',
} as const;

export const SIZE = {
  small: 'small',
  medium: 'medium',
  smallMedium: 'smallMedium',
} as const;

export const ALIGNMENT = {
  start: 'start',
  center: 'center',
  end: 'end',
} as const;
